 window.$ = window.jQuery = require('jquery');
require('./vendor/modernizr-custom');
require("@popperjs/core");
require ('bootstrap');
require('jquery-nice-select');
require("@fancyapps/fancybox");

import AOS from 'aos';

import objectFitVideos from 'object-fit-videos';
import objectFitImages from 'object-fit-images';

import gaEvents from './vendor/ga-events';
import nav from './_nav';
import forms from './_forms';
import sliders from './_sliders';
import fancybox from './_fancybox';
import modules from './_modules';
import cursor from './_cursor';
import sponsorships from './_sponsorships';
import news from './_news';
import media from './_media';
import companies from './_companies';

$(function() { // Shorthand for $( document ).ready()
    "use strict";
    // Your js script is below this line
    // --------------------------------------------------------------------- //

    window.Nav = new nav();
    Nav.init();

    window.Cursor = new cursor();
    Cursor.init();

    window.GA = new gaEvents();
    GA.init();

    window.Forms = new forms();
    Forms.init();

    window.Sliders = new sliders();
    Sliders.init();

    window.Modules = new modules();
    Modules.init();

    window.Fancybox = new fancybox();
    Fancybox.init();

    window.Sponsorships = new sponsorships();
    Sponsorships.init();

    window.News = new news();
    News.init();

    window.Media = new media();
    Media.init();

    window.Companies = new companies();
    Companies.init();

    $(document).ready(function() {
        $('a[href^="#"]').on('click',function(event){
            event.preventDefault();
            let target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
            //change this number to create the additional off set
            let navheight = $('header .navbar').outerHeight();

            // Check for secondary menu
            let secondaryHeight = $('.secondary-menu').outerHeight();

            $('html, body').animate({scrollTop: target_offset - navheight - secondaryHeight}, 500);
        });

        // WebP background image fallback swap
        const checkWebp = function () {
            if (!Modernizr.webp) {
                let $elements = $('*[data-webp-bg-fallback]');
                $elements.each(function() {
                    let fallback = $(this).data('webp-bg-fallback');
                    $(this).css('background-image', 'url(' + fallback + ')');
                });

                // Update img's with fallback
                let $images = $('*[data-webp-img-fallback]');
                $images.each(function() {
                    let fallback =  $(this).data('webp-img-fallback');
                    $(this).attr('src', fallback);
                });
            }
        };

        $(document).on('ajaxUpdate', function(event, context) {
            checkWebp();
            window.Cursor.init();
        });

        checkWebp();

        AOS.init({
            once: true,
            duration: 500,
            disable: function() {
                return window.innerWidth < 992;
            }
        });

        $('html').addClass('ready');
    });

    window.goToPage = function(page) {
        window.location = page;
    }

    // Sets inputs as filled when Google autocomplete prefills them
    $(window).on('load', function() {
        $('input:-webkit-autofill').each(function(){
            $(this).parents('.form-group').addClass('focused filled');
        });
    });

    objectFitVideos();
    objectFitImages('img');
});